import { render, staticRenderFns } from "./refundcard_transaction.vue?vue&type=template&id=fa00a3e2&"
import script from "./refundcard_transaction.vue?vue&type=script&lang=js&"
export * from "./refundcard_transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports